module.exports = __webpack_public_path__ + "img/home-graphic-fr-BE.2faee586.png";